import { FC, ReactNode, useEffect } from 'react';
import { useRouter } from 'next/router';
import { sendPageViewToLogingress } from '~/utils/logingress/smartphoneMonshinLogingress';
import { sendBookingPageViewToLogingress } from '~/utils/logingress/bookingLogingress';

type Props = {
  children: ReactNode;
};

export const PageViewWatcher: FC<Props> = ({ children }) => {
  const router = useRouter();

  useEffect(() => {
    if (!router.isReady) return;
    sendPageViewToLogingress();

    // 集患サポートのページは、別途ページビューを取っている
    if (router.pathname.includes('booking')) {
      sendBookingPageViewToLogingress();
    }
  }, [router.pathname, router.isReady]);

  return <>{children}</>;
};
